import { gql, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import ComingSoon from '../../../components/ComingSoon';
import useAuth from '../../../hooks/useAuth';
import { ListingDetails_ListingData_listing } from '../../../types/graph/ListingDetails_ListingData';
import Design from './Marketing/Design';
import Facebook from './Marketing/Facebook';

interface Props {
  listing: ListingDetails_ListingData_listing;
}

export interface PostData {
  image: File;
  message: string;
}

const Marketing = ({ listing }: Props) => {
  const { getAccountId } = useAuth();
  const [postData, setPostdata] = useState<PostData | null>(null);
  const [processing, setProcessing] = useState<boolean>(true);

  const { data, loading, error } = useQuery(GET_ACCOUNT, {
    variables: { accountId: getAccountId() },
  });

  if (loading || !data || !data.account) {
    return null;
  }

  return (
    <div className="flex flex-col space-y-4">
      <div className="shadow rounded-lg bg-gray-50">
        {/* <Design
          listing={listing}
          setPostData={setPostdata}
          postData={postData}
          setProcessing={setProcessing}
        /> */}
      </div>
      <div className="shadow rounded-lg bg-white">
        {/* <Facebook
          account={data.account}
          listing={listing}
          postData={postData}
          processing={processing}
        /> */}
        <ComingSoon
          label={`On it's way`}
          title="Social Posts"
          description={`Custom social media posts that save you time marketing your brand. We're building integrations with all the popular social networks to make it that much easier to get seen.`}
        />
      </div>
    </div>
  );
};

export default Marketing;

export const GET_ACCOUNT = gql`
  query ListingMarketing_AccountData($accountId: String!) {
    account(accountId: $accountId) {
      id
      package {
        packageId
        group
        name
        numListings
        numUsers
        flags
      }
      integrations {
        facebook {
          userId
          status
          accessToken
          pages {
            id
            name
            accessToken
          }
        }
      }
    }
  }
`;
